import { enableProdMode, CSP_NONCE } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
 
if (environment.production) {
  enableProdMode();
  window.console.log = function() { };
}
 
const nonce = document
  .querySelector('meta[name="ngCspNonce"]')
  ?.getAttribute('content') || '';
 
platformBrowserDynamic([
  { provide: CSP_NONCE, useValue: nonce }
])
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .catch(err => console.error(err));